export default "__VITE_ASSET__BJA6zXNj__"